// MES 모듈 스토어 초기화 공통 함수
// 탭 닫기, 모든 탭 닫기, 로그아웃 시 스토어 초기화에 사용

// 스토어 초기화 맵
const initMap: Record<string, () => void> = {
		
	};

/**
 * 탭 key에 따라 해당 화면의 스토어를 초기화하는 함수
 * @param key 탭의 고유 키 (예: 'MST1010_R01')
 * @description
 * - 탭을 닫을 때 해당 화면의 상태를 초기화하여 메모리 누수 방지
 * - useUiuxStore의 closeAllTabs, closeOtherTabs, closeRightTabs에서 사용
 * - tabUtils의 handleExitClick에서도 사용
 */
export const initializeTabStore = (key: string): void => {
	// 해당 key에 매핑된 초기화 함수가 있으면 실행
	const initFn = initMap[key];
	if (initFn) {
		try {
			initFn();
		} catch (error) {
			console.error(`[storeInitializer] ${key} 스토어 초기화 중 오류 발생:`, error);
		}
	}
};

/**
 * 등록된 모든 스토어 key 목록을 반환
 * @returns 모든 스토어 key 배열
 */
export const getAllStoreKeys = (): string[] => {
	return Object.keys(initMap);
};

/**
 * 모든 스토어를 초기화하는 함수 (로그아웃 시 사용)
 * @description
 * - resetAllStores에서 사용
 * - 등록된 모든 스토어의 initData()를 호출
 */
export const initializeAllStores = (): void => {
	const allKeys = getAllStoreKeys();
	allKeys.forEach(key => {
		initializeTabStore(key);
	});
};

